import { Paragraph } from '@daren/ui-components'
import formatDate from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import * as React from 'react'
import { Link } from 'remix'

import { useTranslations } from '~/context/translations-provider'

import { getBlogSlug, getRoute } from '~/lib/routes'
import { PageType, LanguageCode } from '~/types/languages'
import type { SanityPost } from '~/types/sanity'

function ArticleCard({
  slug,
  title,
  publishedAt,
  readingTime,
  excerpt,
  lang,
}: SanityPost) {
  const { t } = useTranslations()
  const href = getRoute(
    PageType.blog,
    getBlogSlug(publishedAt, slug as string),
    lang as LanguageCode,
  )

  return (
    <div className="relative w-full">
      <Link
        prefetch="intent"
        to={href}
        className="group peer block relative w-full focus:outline-none"
      >
        <p className="text-sm text-gray-500">
          <time dateTime={publishedAt}>
            {formatDate(parseISO(publishedAt), 'PPP')} —{' '}
            {readingTime
              ? `${readingTime} ${t('blog-read-time')}`
              : t('blog-quick-read')}
          </time>
        </p>
        <div className="block mt-2">
          <Paragraph className="text-xl font-semibold text-primary">
            {title}
          </Paragraph>
          <Paragraph className="mt-3 text-base text-secondary">
            {excerpt && `${excerpt.substring(0, 150)}...`}
          </Paragraph>
        </div>
        <div className="mt-3">
          <span className="text-base font-semibold group-hover:text-accent text-primary">
            {t('blog-read-more')}
          </span>
        </div>
      </Link>
    </div>
  )
}

export { ArticleCard }
